import React from 'react'
import { DialogContainer } from '@adobe/react-spectrum'
import Container from './Components/Container'
import PermissionDialog from '../../Layout/PermissionDialog/PermissionDialog'
import { usePermissionCheck } from '../../hooks/usePermissionCheck'

const Chat = () => {

  const {
    permissionResult,
    shouldShowDialog: shouldShowPermissionDialog,
    dismissDialog: dismissPermissionDialog,
    onPermissionsGranted
  } = usePermissionCheck()

  const shouldRenderChat = permissionResult?.allPermissionsGranted ?? false
  const allPermissionsGranted = permissionResult?.allPermissionsGranted ?? false

  // Only allow dismissing if permissions are granted
  const handleDismiss = () => {
    if (allPermissionsGranted) {
      dismissPermissionDialog()
    }
  }

  return (
    <>
      {shouldRenderChat && <Container />}
      <DialogContainer onDismiss={handleDismiss} type='modal'>
        {shouldShowPermissionDialog && (
          <PermissionDialog
            isOpen={shouldShowPermissionDialog}
            onPermissionsGranted={onPermissionsGranted}
            onClose={dismissPermissionDialog}
          />
        )}
      </DialogContainer>
    </>
  )
}

export default Chat